import COUNTRIES from '../countries.translations'

import translations from './germanium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/germanium'

export const germanium: Metal = {
  id: 26,
  slug: 'germanium',
  name: t.name,
  symbol: 'Ge',
  // No dedicated mines — recovered as a by-product of zinc smelting and coal ash.
  mines: [
    {
      name: 'Lincang (China, germanium processing)',
      region: t.mine0Region,
      slug: 'lincang',
      coordinates: [100.09, 23.88],
    },
    {
      name: 'Xilinhot (China, germanium processing)',
      region: t.mine1Region,
      slug: 'xilinhot',
      coordinates: [116.09, 43.95],
    },
    {
      name: 'Olen (Belgium, germanium processing)',
      region: t.mine2Region,
      slug: 'olen',
      coordinates: [4.86, 51.14],
    },
  ],
  countries: [
    { name: COUNTRIES.china, percent: 68 },
    { name: COUNTRIES.russia, percent: 4 },
  ],
  related: ['zinc'],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['electronics', 'camera'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 2, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 4, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'horizontal',
          credit: 'GFOTO / Getty',
        },
      ],
    },
  },
}
